import { render, staticRenderFns } from "./ViewGroupSlidebar.vue?vue&type=template&id=38dfb0c9"
import script from "./ViewGroupSlidebar.vue?vue&type=script&lang=js"
export * from "./ViewGroupSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports